// src/storeAPIs/StoreOrdersApis.js
import apiClient from "../utils/Http";

// ===== PAYMENT INFO =====
export const storeGetPaymentInfo = () =>
  apiClient.get("api/store/payment-info/");

// ===== ORDERS — CUSTOMER =====
export const storeCreateOrder = (data) =>
  apiClient.post("api/store/orders/", data);

export const storeGetMyOrders = (params = {}) =>
  apiClient.get("api/store/orders/mine/", { params });

export const storeGetOrder = (id) =>
  apiClient.get(`api/store/orders/${id}/`);

// ===== ORDERS — STAFF =====
export const storeGetAllOrders = (params = {}) =>
  apiClient.get("api/store/orders/all/", { params });

export const storeGetOrdersByStatus = (status, params = {}) =>
  apiClient.get("api/store/orders/all/", {
    params: { ...params, status },
  });

export const storeGetOrdersByMethod = (method, params = {}) =>
  apiClient.get("api/store/orders/all/", {
    params: { ...params, payment_method: method },
  });

export const storeGetUnconfirmedOrders = (params = {}) =>
  apiClient.get("api/store/orders/all/", {
    params: { ...params, is_confirmed: false },
  });

export const storeGetConfirmedOrders = (params = {}) =>
  apiClient.get("api/store/orders/all/", {
    params: { ...params, is_confirmed: true },
  });

// ===== ORDERS — PAGINATION =====
export const storeGetOrdersPage = (page = 1, pageSize = 20, params = {}) =>
  apiClient.get("api/store/orders/all/", {
    params: { ...params, page, page_size: pageSize },
  });

// StoreOrdersApis.js — add these
export const storeConfirmOrder = (id) =>
  apiClient.post(`api/store/orders/${id}/confirm/`);

export const storeCancelOrder = (id) =>
  apiClient.post(`api/store/orders/${id}/cancel/`);

export const storeGetOrderStats = () =>
  apiClient.get("api/store/orders/stats/");